"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var abClick_1 = require("./abClick");
var abImpression_1 = require("./abImpression");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ABTestEventNames.ABClick] = abClick_1.abClick,
    _a[analytics_layer_1.ABTestEventNames.ABImpression] = abImpression_1.abImpression,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
